<template>
  <ul :class="['conference-data', { 'conference-data--small': small }]">
    <li>
      <Calendar color="currentColor" :size="24" />
      <time>
        {{ date || $t("event.date") }}
      </time>
    </li>
    <li>
      <MapPin color="currentColor" :size="24" />
      {{ location || $t("event.location") }}
    </li>
  </ul>
</template>

<script>
import { MapPin, Calendar } from "lucide-vue-next";

export default {
  name: "ConferenceInfo",
  components: { MapPin, Calendar },
  props: {
    small: {
      type: Boolean,
      default: false,
    },
    date: {
      type: String,
      default: null,
    },
    location: {
      type: String,
      default: null,
    },
  },
};
</script>

<style scoped>
.conference-data {
  display: flex;
  flex-direction: column;
  gap: 0;
  list-style: none;
  padding: 0;
}
.conference-data li {
  padding: 0.5rem 0;
  display: flex;
  align-items: center;
  gap: 1rem;
  line-height: 1.5rem;
}
@media screen and (min-width: 768px) {
  .conference-data li {
    padding: 15px 0;
  }
  .conference-data--small li {
    padding: 6px 0;
  }
}

.conference-data--small li {
  padding: 6px 0;
}
</style>
